import { styled } from '../../../../modules';

function hexToRgba(hex: string, alpha: number): string {
    let c = hex.replace('#', '');
    if (c.length === 3) {
        c = c.split('').map((x) => x + x).join('');
    }
    const num = parseInt(c, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r},${g},${b},${alpha})`;
}

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
`;

export const Header = styled.header`
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 24px;
    min-height: 80px;
`;

export const LogoImage = styled.img`
    max-height: 48px;
    max-width: 180px;
    object-fit: contain;
`;

export const HeroSection = styled.div`
    flex: 1;
    width: 100%;
    padding: 24px 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const CheckIconWrapper = styled.div<{ $color: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
    color: ${({ $color }) => $color};
`;

export const Title = styled.h1<{ $accentColor: string }>`
    font-size: 22px;
    font-weight: 400;
    color: ${({ $accentColor }) => $accentColor};
    margin: 0;
    line-height: 1.4;
    text-align: center;

    strong {
        font-weight: 800;
    }
`;

export const Description = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #718096;
    margin: 0;
    text-align: center;
    line-height: 1.6;
`;

export const ActionSection = styled.div`
    width: 100%;
    padding: 8px 24px 32px;
`;

export const AppBannerSection = styled.div<{ $accentColor: string }>`
    width: 100%;
    background: ${({ $accentColor }) => `
        radial-gradient(
            circle at top left,
            ${hexToRgba($accentColor || '#0e3573', 0.82)} 0%,
            ${hexToRgba($accentColor || '#0e3573', 0.92)} 100%
        )
    `};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 24px 20px 20px;
    flex-shrink: 0;
`;

export const BannerContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const BannerTextGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

export const BannerTitle = styled.h2`
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    line-height: 1.3;
`;

export const BannerDescription = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    line-height: 1.4;

    strong {
        font-weight: 700;
        color: #ffffff;
    }
`;

export const StoreBadge = styled.img`
    height: 56px;
    width: auto;
    flex-shrink: 0;
`;

export const PoweredByWrapper = styled.div`
    a span {
        color: rgba(255, 255, 255, 0.55) !important;
    }
    img {
        filter: brightness(10);
    }
`;

export const PlainFooter = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 20px;
    background-color: #ffffff;
    flex-shrink: 0;
`;
